import React from 'react'
import { string, func, number } from 'prop-types'
import classnames from 'classnames/bind'

import rightSVG from '../../assets/result_right.svg'
import wrongSVG from '../../assets/result_wrong.svg'

import styles from './index.module.css'

const cx = classnames.bind(styles)

export default function OptionButton(props) {
  const { text, size, status, handleBtnClick, index } = props

  const handleClick = () => {
    if (status === 'initial') {
      handleBtnClick(index)
    }
  }

  return (
    <div
      className={cx('button', {
        big: size === 'big',
        wrong: status === 'wrong',
        right: status === 'right',
        hide: status === 'hide',
        selected: status === 'selected'
      })}
      onClick={handleClick}
    >
      {status !== 'hide' && <span>{text}</span>}
      {status === 'right' && <img src={rightSVG} alt='' />}
      {status === 'wrong' && <img src={wrongSVG} alt='' />}
    </div>
  )
}

OptionButton.propTypes = {
  text: string.isRequired,
  size: string,
  status: string,
  index: number,
  handleBtnClick: func
}
